import * as React from "react";
import { useRoute } from "../../../routing/router.ts";
import { NavItemData, onNavClick } from "../nav.tsx";
import { useCommonDialogs } from "../../CommonDialogsProvider.tsx";
import { NavCount } from "../NavCount.tsx";

interface Props {
  item: NavItemData;
}

export const SideNavItem: React.FC<Props> = ({ item }) => {
  const commonDialogs = useCommonDialogs();
  const route = useRoute();
  const isSelected = item.getIsSelected({ route });
  return (
    <a
      className="sidebar-item"
      href={item.href}
      aria-current={isSelected ? "page" : undefined}
      onClick={onNavClick(item, commonDialogs)}
    >
      {item.icon}
      {item.label}
      {item.countKind && <NavCount kind={item.countKind} />}
    </a>
  );
};
